import { call, cancel, fork, put, take, takeLatest } from 'redux-saga/effects';
import {
  getAddonProductsApi,
  updateAddonProductPriceApi,
  getAdditionalServiceLogs,
} from 'api/additionalService';
import { errorMessage, successMessage } from 'state/toast/actions';
import {
  GET_ADDON_PRODUCTS,
  UPDATE_ADDON_PRODUCT_PRICE,
  ADDITIONAL_SERVICE_DO_SHOW_LOG,
  ADDITIONAL_SERVICE_LOG_CHANGE_PAGE,
  ADDITIONAL_SERVICE_LOG_SET_SHOWN,
} from './actionTypes';
import {
  updateAddonProducts,
  setAddonProductsLoading,
  setPriceEditorLoading,
  setPriceEditorError,
  showEditPriceModal,
  getAddonProducts,
  setLogData,
  setLogIsLoading,
  setLogErrors,
  clearLogErrors,
  resetLogData,
  setLogModalShown,
  setLogPage,
} from './actions';

export function* handleGetAddonProducts() {
  try {
    yield put(setAddonProductsLoading(true));
    const response = yield call(getAddonProductsApi);
    yield put(updateAddonProducts(response.data.data || []));
  } catch (error) {
    yield put(errorMessage('Error', 'Failed to load addon products'));
  } finally {
    yield put(setAddonProductsLoading(false));
  }
}

export function* handleUpdateAddonProductPrice(action) {
  const { productId, priceData } = action.payload;

  try {
    yield put(setPriceEditorLoading(true));
    yield put(setPriceEditorError(null));

    yield call(updateAddonProductPriceApi, productId, priceData);

    yield put(showEditPriceModal(false, null));
    yield put(successMessage('Success', 'Price updated successfully'));
    yield put(getAddonProducts());
  } catch (error) {
    const errorMsg =
      (error &&
        error.response &&
        error.response.data &&
        error.response.data.message) ||
      'Failed to update price';
    yield put(setPriceEditorError(errorMsg));
    yield put(errorMessage('Error', errorMsg));
  } finally {
    yield put(setPriceEditorLoading(false));
  }
}

function* logModalTask() {
  while (true) {
    const { page } = (yield take(ADDITIONAL_SERVICE_LOG_CHANGE_PAGE)).payload;
    yield put(setLogIsLoading(true));
    yield put(clearLogErrors());
    yield put(resetLogData());
    try {
      const {
        data: {
          data: { internal_tools_activities: activities },
          paging,
        },
      } = yield call(getAdditionalServiceLogs, page, 20);
      yield put(setLogData(activities, paging));
    } catch (e) {
      yield put(setLogErrors(e.message || ['Failed to load logs']));
    } finally {
      yield put(setLogIsLoading(false));
    }
  }
}

export function* doShowLogs() {
  const task = yield fork(logModalTask);
  yield put(setLogPage(1));
  yield put(setLogModalShown(true));
  let closeModalRequest;
  do {
    closeModalRequest = (yield take(ADDITIONAL_SERVICE_LOG_SET_SHOWN)).payload;
  } while (closeModalRequest.shown);
  yield cancel(task);
}

export default function* additionalServiceSaga() {
  yield takeLatest(GET_ADDON_PRODUCTS, handleGetAddonProducts);
  yield takeLatest(UPDATE_ADDON_PRODUCT_PRICE, handleUpdateAddonProductPrice);
  yield takeLatest(ADDITIONAL_SERVICE_DO_SHOW_LOG, doShowLogs);
}
